import React from 'react';
import SbEditable from 'storyblok-react';
import LinkWrap from '../link_wrap';

import './cta-button-link.scss';

const CTAButtonLink = (props) => {
  const classes = ['cta-button-link'];
  classes.push('cta-style-' + props.blok.style);

  return (
    <SbEditable content={props.blok}>
      <div className={classes.join(' ')}>
        <LinkWrap to={props.blok.target}>{props.blok.text}</LinkWrap>
      </div>
    </SbEditable>
  );
};

export default CTAButtonLink;
